import MENU_LIST from './Menu.list';
import USER_SETTINGS from './UserSettings.list';
import FILTER_LIST from './Filter.list';

export default { MENU_LIST, USER_SETTINGS, FILTER_LIST };
